export default __webpack_public_path__ + "static/og-image-a78391a9a1b23107fae78f9580299ae6.png";